export default {
  name: 'language-selector-hsia',
  data: () => ({
    onBodyClick: null
  }),
  mounted() {
    const activator = this.$el.querySelector('.activator')
    activator.addEventListener('click', this.onClick)
  },
  methods: {
    onClick(e) {
      e.stopPropagation()
      const target = e.target
      const langDropdown = this.$el.querySelector('ul.langs')
      const body = document.getElementsByTagName('body')[0]
      if (langDropdown.classList.contains('opened')) {
        langDropdown.classList.remove('opened')
        target.classList.remove('opened')
        target.setAttribute('aria-expanded', 'false')
        body.removeEventListener('click', this.onBodyClick)
      } else {
        langDropdown.classList.add('opened')
        target.classList.add('opened')
        target.setAttribute('aria-expanded', 'true')
        this.onBodyClick = this.onClick.bind(this, e)
        body.addEventListener('click', this.onBodyClick)
      }
    }
  },
  render() {
    return this.$scopedSlots.default()
  }
}